import { ErrorState } from "$components/error-state";
import { LoadingPage } from "$components/loading/loading-page";
import { linkToAuth0Callback } from "$routes/user/links";
import { useAuth0 } from "@auth0/auth0-react";
import * as React from "react";
import { useNavigate } from "react-router-dom";

export const RedirectToAuth0Login = () => {
  const navigate = useNavigate();
  const { isLoading, loginWithRedirect, user, isAuthenticated, error } =
    useAuth0();

  React.useEffect(() => {
    (async function login() {
      if (!isLoading && !user && !error) {
        await loginWithRedirect({
          // Take users to the login page regardless of how far they got last time
          // Without this users can get "stuck on the MFA page": https://community.auth0.com/t/classic-universal-login-stuck-on-mfa-page-sms/42025/3
          prompt: "login",
        });
      }
    })();
  }, [isLoading, loginWithRedirect, user, error]);

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate(linkToAuth0Callback());
    }
  }, [isAuthenticated, navigate]);

  if (error) {
    return (
      <ErrorState
        error={error}
        onRetry={() => loginWithRedirect({ prompt: "login" })}
      />
    );
  }

  if (isLoading || !isAuthenticated) {
    return <LoadingPage />;
  }

  return null;
};
